import React from 'react'
import PropTypes from 'prop-types'

import { compose, withApollo } from 'react-apollo'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Link, withRouter } from 'react-router-dom'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'
import { styles } from './styles'
import { isMobile } from '../../utils'
import Version from '../../components/Version'
import { connect } from 'react-redux'
import { login } from '../../stores/auth'

const logo = require('../../assets/images/g2g.png')
const validationSchema = () => {
  return yup.object().shape({
    email: yup
      .string()
      // .email('รูปแบบอีเมลไม่ถูกต้อง')
      .required('จำเป็นต้องระบุ'),
    password: yup.string().required('จำเป็นต้องระบุ')
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { history, enqueueSnackbar, login } = props
  setSubmitting(true)
  try {
    const { email, password } = values
    login(history, { email, password })
  } catch (error) {
    enqueueSnackbar(error.message)
  }
  setSubmitting(false)
}

export const Login = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting,
  history
}) => {
  return (
    <React.Fragment>
      <AppBar position="absolute">
        <Toolbar>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => history.goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            Login
          </Typography>
        </Toolbar>
      </AppBar>
      <main style={styles.main}>
        <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
          <Avatar src={logo} style={styles.avatar} />
          <Typography id="titlePage" variant="h5">
            Green2Get
          </Typography>
          <Tabs value="0" indicatorColor="primary" textColor="primary">
            <Tab label="เข้าสู่ระบบ" />
          </Tabs>
          <div>
            <form onSubmit={handleSubmit}>
              <div>
                <FormControl
                  margin="normal"
                  fullWidth
                  error={touched.email && Boolean(errors.email)}>
                  <TextField
                    id="inputEmail"
                    type="text"
                    name="email"
                    label="อีเมลหรือเบอร์โทรศัพท์"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                  />
                  {touched.email && errors.email && (
                    <FormHelperText>{errors.email}</FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  margin="normal"
                  fullWidth
                  error={touched.password && Boolean(errors.password)}>
                  <TextField
                    id="inputPassword"
                    type="password"
                    name="password"
                    label="รหัสผ่าน (Password)"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.password && Boolean(errors.password)}
                  />
                  {touched.password && errors.password && (
                    <FormHelperText>{errors.password}</FormHelperText>
                  )}
                </FormControl>
              </div>

              {isSubmitting ? (
                <Button disabled fullWidth style={styles.button}>
                  Signing In...
                </Button>
              ) : (
                <Button
                  id="btnLogin"
                  variant="contained"
                  type="submit"
                  color="primary"
                  style={styles.button}
                  fullWidth>
                  Sign In
                </Button>
              )}
            </form>
          </div>
        </Paper>
        <div
          style={{
            marginTop: '1em'
          }}>
          <Button id="btnRegister" color="primary" fullWidth>
            <Link href="#" to="/signup" style={styles.link}>
              ลงทะเบียน (Register)
            </Link>
          </Button>
          <Button id="btnForgotPassword" color="primary" fullWidth>
            <Link href="#" to="/forgot-password" style={styles.link}>
              ลืมรหัสผ่าน (Forgot Password)
            </Link>
          </Button>
        </div>
        <Version color="grey" />
      </main>
    </React.Fragment>
  )
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
}

const mapDispatchToProps = {
  login
}

export default compose(
  withRouter,
  withSnackbar,
  withApollo,
  connect(null, mapDispatchToProps),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => {
      return {
        email: '',
        tel: ''
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'LoginForm'
  })
)(Login)



// WEBPACK FOOTER //
// ./src/pages/Login/index.js